import React, { useEffect, useState, createContext, useMemo } from 'react';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { initFirebaseService } from '../../dealerLocator.utils';

export const FirebaseContext = createContext<{ app: any; firebase: any }>({ app: null, firebase: null });

const FirebaseContextProvider = ({ children, model }) => {
  const [loadingFirebase, setLoadingFirebase] = useState(false);
  const [app, setApp] = useState<unknown>(null);
  const [firebase, setFirebase] = useState<unknown>(null);
  const ctx = useMemo(() => ({ app, firebase }), [app, firebase]);
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-l']})`);

  useEffect(() => {
    if (firebase || !model.firebaseConfig || loadingFirebase || !isWide) {
      return;
    }

    // Lazy Load Firebase package to avoid SSR errors caused by Firebase side effects durring SSR.
    initFirebaseService(model.firebaseConfig)
      .then(({ firebase, app }) => {
        setApp(app);
        setFirebase(firebase);
      })
      .catch((err) => {
        console.error('Error: Failed to initialize Firebase: ', err);
        setApp(null);
        setFirebase(null);
      });
    setLoadingFirebase(true);
  }, [model.firebaseConfig, isWide]);

  return <FirebaseContext.Provider value={ctx}>{children}</FirebaseContext.Provider>;
};

export default FirebaseContextProvider;
